var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero__container",style:(_vm.style)},[_vm._t("logo"),(_vm.title)?_c('h1',{staticClass:"hero__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.desc)?_c('div',{staticClass:"hero__desc",domProps:{"innerHTML":_vm._s(_vm.desc)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }